import type {ReactElement} from 'react';
import React from 'react';
import {getOpenedModal} from '@Components/modal-container/modal-container-reducer';
import {MODALS_IDS} from '@Components/modal-container';
import {GlobalPosterEditorJqueryElement} from '@Components/poster-editor/poster-editor.types';
import {POSTER_PUSH_MODAL_IDS} from '@Components/poster-editor/components/post-poster-modal-spacer/post-poster-modal-spacer.types';
import {useAppSelector} from '@/hooks';
import styles from './post-poster-modal-spacer.module.scss';
import {useIsVideoOrHasMultiPages} from '@Hooks/poster-editor/useIsVideoOrHasMultiPages';

const MIN_POSTER_WHITEBOARD_HEIGHT = 200;

export function PostPosterModalSpacer(): ReactElement<any> {
  const isPosterVideo = useIsVideoOrHasMultiPages();
  const openedModalData = useAppSelector(getOpenedModal);
  const bottomBarHeight = window.posterEditor?.elements[GlobalPosterEditorJqueryElement.POSTER_EDITOR_MOBILE_BOTTOM_EDITING_BAR]?.outerHeight(true) || 0;
  const navbarHeight = window.posterEditor?.elements[GlobalPosterEditorJqueryElement.POSTER_EDITOR_NAVBAR]?.outerHeight(true) || 0;
  let height = 0;
  if (openedModalData && POSTER_PUSH_MODAL_IDS[openedModalData.modalId] && openedModalData.modalData.height) {
    height = Math.max(openedModalData.modalData.height - bottomBarHeight, 0);
  }

  if (openedModalData && openedModalData.modalId === MODALS_IDS.POSTER_EDITOR_MORE_OPTIONS_MODAL) {
    if (openedModalData.modalData.height && openedModalData.modalData.height < 100) {
      height = 0;
    }
  }

  const getMaxHeight = (): number => {
    return window.innerHeight - MIN_POSTER_WHITEBOARD_HEIGHT - navbarHeight - bottomBarHeight - (isPosterVideo ? 80 : 0);
  };

  return (
    <div
      className={styles.container}
      style={{
        maxHeight: `${getMaxHeight()}px`,
        minHeight: `${height > getMaxHeight() ? getMaxHeight() : height}px`,
        height: `${height}px`,
        width: '1px',
      }}
    />
  );
}
